declare namespace $ {

	export class $shm_hitalama_map_widget_float_code_textarea extends $shm_hitalama_textarea {
		reveal_pending( ): boolean
		reveal_watch( ): any
		lazy_enabled( ): boolean
		attr( ): ({ 
			'shm_hitalama_map_widget_float_code_textarea_pending': ReturnType< $shm_hitalama_map_widget_float_code_textarea['reveal_pending'] >,
			'aria-busy': ReturnType< $shm_hitalama_map_widget_float_code_textarea['reveal_pending'] >,
		})  & ReturnType< $shm_hitalama_textarea['attr'] >
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=textarea.view.tree.d.ts.map